import { map, set } from 'lodash';
import React, { Component } from 'react';
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import Overview from './Overview';
import Cleaning from './Cleaning';
import Customized from './Customized';
import InitialCleaning from './InitialCleaning';
import FranchiseAlerts from './FranchiseAlerts';
import SetupOptions from './SetupOptions';
import FranchiseServiceNotifications from './FranchiseServiceNotifications';
import Loader from '../../../Common/Component/Loader';
import {isEmpty} from 'lodash';

class FranchiseDetails extends Component {

  state = {
    franchise_data: {},
    current: 0,
    tabs: [
      'Overview',
      'Standard Cleaning',
      'Customized Cleaning',
      'Initial Cleaning',
      'Franchise Alerts',
      'SETUP OPTIONS',
      'Franchise Service Notifications',
    ],
    loader: false,
    updateHandlerState: null,
    initialCleaningRefereshCount: 0,
    hideFooter: false,
  }

  setHideFooter = (hideFooter) => {
    this.setState({
      hideFooter
    })
  }

  setUpdateHandlerState = (state) => {
    this.setState({
      updateHandlerState: state
    })
  }

  updateHandlerFunc = () => {
    if(this.state.updateHandlerState) {
      this.setState({loader: true});
      setTimeout(() => {
        this.props.saveArea(this.state.updateHandlerState)
        this.setState({loader: false});
      }, 1000)
      
    }
  }

  componentDidMount = async () => {
    
    let is_stripe_connect = localStorage.getItem('is_stripe_connect') || null
    if (is_stripe_connect) {
      this.setState({
        current: 5
      });

      localStorage.removeItem('is_stripe_connect');
    }

    //for quickbooks
    const franchise_data = JSON.parse(localStorage.getItem('temp_franchise'))
    if (this.props?.location?.search && !isEmpty(franchise_data?.data)) {
      const search = this.props?.location?.search
      this.props.loginCallbackQuickbook(franchise_data?.data?.uuid, search)
    }
    if (!this.props.history.location.state) {
      this.props.history.push(`/franchise`);
    }

    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";


    if (accessToken) {
      if (this.props.history.location.state) {
        this.setState({
          franchise_data: this.props.history.location.state.query.data,
        })
      }
    }
    else {
      window.location.assign('/')
      localStorage.clear();
      sessionStorage.clear();
    }

  }

  updateFranchiseData = (data) => {
    this.setState({
      franchise_data: data
    })
    localStorage.setItem('temp_franchise', JSON.stringify({ 'data': data}))

  }

  //Reder Step
  RenderAllStep = () => {
    let { current } = this.state;
    switch (current) {
    case 0:
      return <Overview {...this.props} />
    case 1:
      return <Cleaning
        // API
        getStandardCleaning={this.props.getStandardCleaning}
        updateStandardCleaning={this.props.updateStandardCleaning}
        //Reducers
        StandardCleaning={this.props.StandardCleaning}
        UpdatePriceMatrix={this.props.UpdatePriceMatrix}
        history={this.props.history}

      />
    case 2:
      return <Customized
        // Reducers
        EditFieldOffice={this.props.EditFieldOffice}
        UpdateFranchise={this.props.UpdateFranchise}
        AddonUpdated={this.props.AddonUpdated}
        // API
        editFieldOffice={this.props.editFieldOffice}
        updateFieldOffice={this.props.updateFieldOffice}
        updateFieldAddOn={this.props.updateFieldAddOn}
        history={this.props.history}
      />
    // case 3:
    //   return <InitialCleaning
    //     //Reducers
    //     AddInitial={this.props.AddInitial}
    //     GetInitial={this.props.GetInitial}
    //     DeleteInitial={this.props.DeleteInitial}
    //     // API
    //     getIntialCleaning={this.props.getIntialCleaning}
    //     addIntialCleaning={this.props.addIntialCleaning}
    //     deleteIntialCleaning={this.props.deleteIntialCleaning}
    //     history={this.props.history}
    //   />
    case 3:
      return <InitialCleaning
        //Reducers
        AddInitial={this.props.AddInitial}
        GetInitial={this.props.GetInitial}
        DeleteInitial={this.props.DeleteInitial}
        // API
        getIntialCleaning={this.props.getIntialCleaning}
        addIntialCleaning={this.props.addIntialCleaning}
        deleteIntialCleaning={this.props.deleteIntialCleaning}
        getAllZipCodes={this.props.getAllZipCodes}
        history={this.props.history}
        {
          ...{
            ...this.props, 
            setUpdateHandlerState: this.setUpdateHandlerState,
            refreshCount: this.state.initialCleaningRefereshCount,
            setHideFooter: this.setHideFooter,
          }
        }
      />
    case 4:
      return <FranchiseAlerts
        // API
        addFieldAlert={this.props.addFieldAlert}
        getFieldAlert={this.props.getFieldAlert}
        updateFieldAlert={this.props.updateFieldAlert}

        // Reducers
        NewFieldAlert={this.props.NewFieldAlert}
        FieldAlertsGet={this.props.FieldAlertsGet}
        UpdateAlert={this.props.UpdateAlert}

        history={this.props.history}
      />
    case 5:
      return <SetupOptions
        franchise_data={this.state.franchise_data}
        //function
        updateFranchiseData = { this.updateFranchiseData }
        // API
        loginWithStripe={this.props.loginWithStripe}
        loginWithQuickbook={this.props.loginWithQuickbook}
        updateOptimorouteKey={this.props.updateOptimorouteKey}
        getOptimorouteKey={this.props.getOptimorouteKey}
        getStaxKeys={this.props.getStaxKeys}
        updateStaxKeys={this.props.updateStaxKeys}
        getPulseMKeys={this.props.getPulseMKeys}
        updatePulseMKeys={this.props.updatePulseMKeys}
        //Reducers
        OptimorouteKey={this.props.OptimorouteKey}
        StripeLogin={this.props.StripeLogin}
        QuickbookLogin={this.props.QuickbookLogin}
        StaxKeys={this.props.StaxKeys}
        UpdateStaxKeys={this.props.UpdateStaxKeys}
        PulseMKeys={this.props.PulseMKeys}
        UpdatePulseMKeys={this.props.UpdatePulseMKeys}
      />
    case 6:
      return <FranchiseServiceNotifications
        franchise_data={this.state.franchise_data}
        //function
        updateFranchiseData = { this.updateFranchiseData }
        // API
        getServiceNotificationKeys={this.props.getServiceNotificationKeys}
        updateServiceNotificationKeys={this.props.updateServiceNotificationKeys}
        //Reducers
        ServiceNotificationKeys={this.props.ServiceNotificationKeys}
        UpdateServiceNotificationKeys={this.props.UpdateServiceNotificationKeys}
      />
    default:
      return <Overview />
    }
  }

  //Change Tab
  tabChange = (current) => {
    this.setState({
      current
    })
  }

  render() {
    let { tabs, current, franchise_data, loader } = this.state;
    return (

      <div id="wrapper">
        <div className="content-area franchisee">
          {/* Header */}
          <Header placeholder="ID & Name, Owner, Address" />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="container">
            <div className="w-1596">
              <div className="filter_wrapper">
                <ul className="breadcrumb">
                  <li><span onClick={() => this.props.history.goBack()} className="pointer">Franchises</span></li>
                  <li><span>{('00' + parseInt(franchise_data.id)).slice(-3)} {franchise_data.city}, {franchise_data.state}</span></li>
                </ul>
              </div>
              <div className="res-head pb-0">
                <div className="flex ai-center mb-20">
                  <div className="user-info no-border" style={{ 'maxWidth': '100%' }}>
                    <h3>{('00' + parseInt(franchise_data.id)).slice(-3)} {franchise_data.city}, {franchise_data.state}</h3>
                  </div>
                </div>
                <ul className="tabs dark">
                  {
                    map(tabs, (item, index) =>
                      <li key={`tab${index}`} className={current === index ? 'active' : ''} onClick={(e) => { e.preventDefault(); this.tabChange(index) }}>
                        <span className="flex ai-center">
                          {item}
                          {item.toLowerCase()?.includes('tickets') && <div className="count"></div>}
                        </span>
                      </li>
                    )
                  }
                </ul>
              </div>

              <div className="step_wrapper">
                {this.RenderAllStep()}
              </div>
              {(current === 3 && !this.state.hideFooter) && <div className="sticky-btn-grp footer-availability">
                <div className="flex ai-center">
                  <div className="flex-1">
                    <button 
                      onClick={() => {
                        this.setState({
                          initialCleaningRefereshCount: this.state.initialCleaningRefereshCount + 1
                        })
                      }}
                      className='btn btn-brand btn-bdr'>Cancel</button>
                    <button
                      onClick={this.updateHandlerFunc}
                      className='btn btn-warning'>Update Availability</button>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default FranchiseDetails;